import styled from 'styled-components';
import { FlexBox } from 'src/ui/common/atoms/flex-box';

const AVATAR_SIZE = 76;

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gs500};
  border-radius: 5px;
  min-width: 200px;
`;

export const StyledInfo = styled.div`
  padding: 55px 20px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
`;

export const StyledCreatorName = styled.div`
  background: ${({ theme }) => theme.colors.gs400};
  margin-bottom: 8px;
  border-radius: 2px;
  height: 10px;
  width: 114px;
`;

export const StyledName = styled(FlexBox)`
    background: ${({ theme }) => theme.colors.gs400};
    border-radius: 2px;
    height: 14px;
    width: 152px;
    margin-bottom: 6px;
`;

export const StyledImgWrapper = styled.div`
  border-radius: 5px;
  overflow: hidden;
`;

export const StyledImgPreviewWrapper = styled.div`
  position: absolute;
  top: -${AVATAR_SIZE / 2}px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 50%;
  width: ${AVATAR_SIZE}px;
  overflow: hidden;
`;

export const StyledDescription = styled.div<{ width: string }>`
  background: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;
  height: 10px;
  width: ${({ width }) => width};
  margin-top: 6px;
`;
